import React from 'react';
import { EuiIcon } from "@elastic/eui";

export default (props: any) => {
  const cellValue = props.value;

  const buttonClicked = () => {
    // alert(`${cellValue} `);
    console.log('buttonClicked', props);
    props.onClick(props.data.idPais, !props.data[props.column.colId], props.column.colId);
  };

  return (
    <EuiIcon type={(cellValue ? "arrowDown" : "arrowUp")} color={(cellValue ? "red" : "green")} size="m" onClick={buttonClicked} />
  );
};